module.exports = __webpack_public_path__ + "static/media/billing-delete.a46b1750.svg";